import React from "react";
import PropTypes from "prop-types";
import IconWrapper from "components/icons/IconWrapper";

const EmailIcon = ({
  className = "",
  inline,
  width = "100px",
  height = "100px"
}) => (
  <IconWrapper className={`icon ${className}`} inline={inline}>
    <svg
      height={height}
      width={width}
      fill="#2E404F"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      style={{ enableBackground: "new 0 0 100 100" }}
      xmlSpace="preserve"
    >
      <g>
        <path d="M98.8,57.8L82,17.2c-0.2-0.6-0.7-1-1.2-1.2c-0.6-0.2-1.2-0.2-1.7,0L23,39.2c-0.6,0.2-1,0.7-1.2,1.2c-0.2,0.6-0.2,1.2,0,1.7   l16.8,40.6c0.4,0.9,1.2,1.4,2.1,1.4c0.3,0,0.6-0.1,0.9-0.2l56.1-23.2C98.8,60.3,99.3,59,98.8,57.8z M63.7,58.2L29.4,41.4l46.6-19.3   L63.7,58.2z M64,63.4c0.3,0.2,0.7,0.2,1,0.2c0.3,0,0.6-0.1,0.9-0.2c0.6-0.2,1.1-0.7,1.3-1.4L72,48l19.4,10.5L44.3,78l6.3-21.2   L64,63.4z M92.3,53.9L73.4,43.7l6.6-19.3L92.3,53.9z M28.2,45.8l18.4,9l-6.1,20.6L28.2,45.8z" />
        <path d="M3.3,51.1h13.1c1.2,0,2.3-1,2.3-2.3c0-1.2-1-2.3-2.3-2.3H3.3c-1.2,0-2.3,1-2.3,2.3C1,50,2,51.1,3.3,51.1z" />
        <path d="M25.7,72.2H3.3c-1.2,0-2.3,1-2.3,2.3c0,1.2,1,2.3,2.3,2.3h22.4c1.2,0,2.3-1,2.3-2.3C27.9,73.2,26.9,72.2,25.7,72.2z" />
        <path d="M3.3,63.9H21c1.2,0,2.3-1,2.3-2.3c0-1.2-1-2.3-2.3-2.3H3.3c-1.2,0-2.3,1-2.3,2.3C1,62.9,2,63.9,3.3,63.9z" />
      </g>
    </svg>
  </IconWrapper>
);

EmailIcon.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  inline: PropTypes.bool,
  width: PropTypes.string
};

export default EmailIcon;
